import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { SettingsGroup, SettingsRow } from '../components/SettingsList';
import { SectionTitle } from '../components/ui/Card';
import { useLocale } from '../contexts/LocaleContext';
const groups: {
  title: string;
  kinds: string[];
}[] = [{
  title: 'states.group.loading',
  kinds: ['loading', 'skeleton']
}, {
  title: 'states.group.content',
  kinds: ['empty', 'no-results', 'no-notifications', 'no-posts', 'no-metrics', 'first-use']
}, {
  title: 'states.group.system',
  kinds: ['offline', 'error', 'maintenance', 'update', 'session']
}, {
  title: 'states.group.access',
  kinds: ['locked', 'camera', 'notifications', 'location', 'photos']
}, {
  title: 'states.group.feedback',
  kinds: ['success']
}];
export function AppStates() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  return <div className="px-2 pb-2" data-id="element-2097" data-mp="1owwzeue1z0pg">
      <PageHeader title={t('states.title')} subtitle={t('states.subtitle')} showBack data-id="element-2098" data-mp="1ox6gttl17zjj" />

      {groups.map(group => <section key={group.title} className="mt-3 first:mt-0" data-id="element-2099" data-mp="2o0kr4nip9b9p">
          <SectionTitle data-id="element-2100" data-mp="2j5drprwgqsql">{t(group.title)}</SectionTitle>
          <SettingsGroup data-id="element-2101" data-mp="2xt8iv3utop1k">
            {group.kinds.map(kind => <SettingsRow key={kind} label={t(`state.${kind}.title`)} hint={t(`state.${kind}.tag`)} onClick={() => navigate(`/estado/${kind}`)} data-id="element-2102" data-mp="2xujnf5w3e0tq" />)}
          </SettingsGroup>
        </section>)}
    </div>;
}